import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { LoadingService } from '../services/loading-service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loading',
  template: `
    <div *ngIf="loading$ | async" class="loading-overlay">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  `,
  styles: [`
    .loading-overlay {
      position: fixed;
      bottom: 16px;
      right: 16px;
      padding: 8px;
      z-index: 9999; 
    }
  `],
})
export class LoadingComponent {
  loading$: Observable<boolean>;

  constructor(private loadingService: LoadingService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
      this.loading$ = this.loadingService.loading$;
      this.cdr.detectChanges();
  }

  ngOnChanges() {
    this.cdr.detectChanges();
  }
}
